"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { commonFormFields } from "@/libs/builder/common/formFields";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const telephoneInputs = [
  ...commonFormFields,
  {
    name: "isRequired",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "isDisabled",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "isWithoutDropdown",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "isInfoMessageVisible",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "showLabel",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "mode",
    type: "string",
    defaultValue: "standard",
    enum: ["standard", "editable"],
  },
  {
    name: "isLocked",
    type: "boolean",
    defaultValue: false,
  },
] as const satisfies Inputs;

export const TelephoneComponent: RegisteredComponent = {
  name: "Telephone",
  component: dynamic(async () => withValidation(telephoneInputs, (await import("./Telephone")).Telephone, "Telephone")),
  inputs: telephoneInputs,
};
